import { render, staticRenderFns } from "./table-brand.vue?vue&type=template&id=5fbe4ace&scoped=true&"
import script from "./table-brand.vue?vue&type=script&lang=js&"
export * from "./table-brand.vue?vue&type=script&lang=js&"
import style0 from "./table-brand.vue?vue&type=style&index=0&id=5fbe4ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe4ace",
  null
  
)

export default component.exports